export const radii = {
  none: '0',
  s: '0.25rem',
  m: '1rem',
  pill: '6.25rem',
  circle: '50%'
};

export type Radii = typeof radii;
